import { Box, Container, Stack, Typography } from "@mui/material";
import ChatContent from "@/templates/ChatContent";
import { BackButton } from "@/organism";
import useCreateContent from "./useCreateContent";

/**
 * QNA 채팅 컨텐츠 생성 페이지
 * @description 새로운 QNA 채팅 컨텐츠를 생성하는 페이지입니다.
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-16
 */
export const CreateContent = () => {
  const { isLoading, handleSubmit } = useCreateContent();

  return (
    <Container maxWidth={"xl"} key="chat-content-create">
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        gap={2}
        alignItems={"end"}
        mb={2}
      >
        <Stack direction={"column"} gap={1}>
          <BackButton to={"/chat/content"}>컨텐츠 목록</BackButton>
          <Typography
            component={"h1"}
            variant="h5"
            fontWeight={"bold"}
            gutterBottom
          >
            컨텐츠 생성
          </Typography>
        </Stack>
      </Box>
      <ChatContent.CreateForm
        key="chat-content-form"
        onSubmit={handleSubmit}
        isLoading={isLoading}
      />
    </Container>
  );
};
